import {
  Map, Marker, Popup, NavigationControl, FullscreenControl
} from 'mapbox-gl';
import MapboxLanguage from '@mapbox/mapbox-gl-language';
import { captureException } from '@sentry/browser';

export default () => {

  const node = document.getElementById('mapbox-data');

  if (node === null) {
    return;
  }

  const data = JSON.parse(node.getAttribute('data'));

  const longitude = data.longitude;
  const latitude = data.latitude;
  const workplaceName = data.workplace_name;
  const device = data.device;

  const DEFAULT_ZOOM_SIZE = 14;

  try {
    const map = new Map({
      accessToken: process.env.MAPBOX_ACCESS_TOKEN,
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [longitude, latitude],
      zoom: DEFAULT_ZOOM_SIZE,
      dragPan: device == 'PC', // SPでは画面スクロール中に誤って地図を動かしてしまうため固定する
      dragRotate: false,
      scrollZoom: false
    });

    map.addControl(new NavigationControl())
      .addControl(new FullscreenControl())
      .addControl(new MapboxLanguage({ defaultLanguage: 'ja' }));

    // SPでは画面スクロール中に誤って地図を動かしてしまうため固定する
    if (device == 'SP'){
      map.on('touchstart', (ev) => {
        if (ev.originalEvent.touches.length === 2) {
          map.dragPan.enable()
        }
      });
      map.on('touchend', () => {
        if (map.dragPan.isEnabled()) map.dragPan.disable()
      });
      // PC版ではSPの用に2本指を使った操作ができないため別のハンドラで動作を再現する
      // 面倒だがエミュレータを解除しないと動作が確認できない
      map.on('mousedown', (ev) => {
        if (ev.originalEvent.metaKey || ev.originalEvent.ctrlKey) {
          map.dragPan.enable()
        }
      });
      map.on('mouseup', () => {
        if (map.dragPan.isEnabled()) map.dragPan.disable()
      });
    }

    const marker = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [longitude, latitude]
      },
      properties: {
        title: workplaceName,
        description: ''
      }
    }

    const template = document.getElementById('marker');
    const clone = document.importNode(template.content, true);
    const el = clone.firstElementChild;

    clone.getElementById('title').innerHTML = marker.properties.description;

    new Marker(el, { anchor: 'bottom' })
      .setLngLat(marker.geometry.coordinates)
      .setPopup(new Popup({ offset: 60, anchor: 'bottom' }) // add popups
        .setHTML('<h3>' + marker.properties.title + '</h3><p>' + marker.properties.description + '</p>'))
      .addTo(map);
  } catch (err) {
    document.getElementById("mapbox-content").remove();
    captureException(err);
  }
}